// Jump links

// Smooth scroll to jump links on the same page without adding to the
// browser history. The back button returns to the previous page instead of
// the last clicked jump link.

const hashedLinks = document.querySelectorAll('a[href*="#"]:not([href="#"],[data-toggle])');

function focusTarget (elem) {
  elem.focus({preventScroll:true}); // Setting focus
  if (document.activeElement !== elem){ // Checking if the target wasn't focused
    elem.setAttribute('tabindex','-1'); // Adding tabindex for elements not focusable
    elem.focus({preventScroll:true}); // Setting focus
  };
}

hashedLinks.forEach(link => link.addEventListener('click', (event) => {
  let link = event.target;

  if (
    location.pathname.replace(/^\//, '') == link.pathname.replace(/^\//, '') &&
    location.hostname == link.hostname
  ) {
    let targetEl = document.querySelector(link.hash);
    if (targetEl) {
      event.preventDefault();
      targetEl.scrollIntoView();
      focusTarget(targetEl);
    }
  } else {
    return true;
  }

}));
